import PasswordValidator from 'password-validator';

const SwiftCodeSchema = new PasswordValidator();

SwiftCodeSchema
  .not().has(/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/);

export const validateSwiftCode = (value: string): boolean | string[] => SwiftCodeSchema.validate(value);
